// extracted by mini-css-extract-plugin
export default {"Emoji":"bcg_a bii_i bii_q bii_j"};